// Commitment status display metadata — FE-042.
//
// Centralises the canonical column order and the visible column label
// (which can differ from the backend status value — see
// ``ready_for_work`` → "Ready") so the Kanban board and any future
// status-grouped surface stay in sync without re-deriving labels per
// component. The status pill itself still lives in
// ``CommitmentStatusBadge`` for legacy reasons; this module is purely
// about the column header treatment.

import type { CommitmentStatus } from "./types";


export const COMMITMENT_STATUSES_ORDERED: CommitmentStatus[] = [
  "backlog",
  "ready_for_work",
  "in_progress",
  "in_review",
  "done",
  "cancelled",
];


// Polish chunk A1: the Kanban defaults to the five "open" lanes;
// Cancelled is opt-in via ``include_cancelled=true`` on the URL or
// an explicit ``status=cancelled`` filter. ``computeVisibleStatuses``
// combines that input into the canonical render order.
export const DEFAULT_BOARD_STATUSES: CommitmentStatus[] = [
  "backlog",
  "ready_for_work",
  "in_progress",
  "in_review",
  "done",
];


export interface CommitmentStatusColumnMeta {
  label: string;
  /** Tailwind class for the small accent dot in the column header. */
  accentDot: string;
}


export const COMMITMENT_STATUS_COLUMN_META: Record<
  CommitmentStatus, CommitmentStatusColumnMeta
> = {
  backlog:        { label: "Backlog",     accentDot: "bg-text-tertiary" },
  ready_for_work: { label: "Ready",       accentDot: "bg-teal" },
  in_progress:    { label: "In progress", accentDot: "bg-sage" },
  in_review:      { label: "In review",   accentDot: "bg-gold" },
  done:           { label: "Done",        accentDot: "bg-teal" },
  cancelled:      { label: "Cancelled",   accentDot: "bg-ember" },
};
